exports = module.exports = require("../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3091nSOVYCujSPCejR6-vG{position:relative}html[dir] ._3091nSOVYCujSPCejR6-vG{margin-bottom:16px}.IBNlXa3VvN6Uanwtr56Tl{position:absolute}.EYIYoX8ERuee2mMTu4l5G{width:100%;height:100%;-o-object-fit:cover;object-fit:cover}html[dir] .EYIYoX8ERuee2mMTu4l5G{border-radius:4px}", ""]);
// Exports
exports.locals = {
	"n-imageGalleryEdit-container": "_3091nSOVYCujSPCejR6-vG",
	"n-imageGalleryEdit-box": "IBNlXa3VvN6Uanwtr56Tl",
	"n-imageGalleryEdit-image": "EYIYoX8ERuee2mMTu4l5G"
};